import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { blackUser } from "@/assets";

const formatHours = (val) => {
  if (val === undefined || val === null || val === "") return "0 H";
  const num = parseFloat(val);
  if (isNaN(num) || num === 0) return "0 H";
  if (num < 1) {
    const mins = Math.round(num * 60);
    return `${mins} Mins`;
  }
  return `${num} H`;
};

export function SingleStaffDetailsTable({ data }) {
  return (
    <>
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead className="w-[100px]">ID</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Designations</TableHead>
            <TableHead>Clock In</TableHead>
            <TableHead>Clock out</TableHead>
            <TableHead>Break Time</TableHead>
            <TableHead>Log Out</TableHead>
            <TableHead>Late Count</TableHead>
            <TableHead>Over Time</TableHead>
            <TableHead>Working Hour</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item?.date || "N/A"}</TableCell>
                <TableCell className="font-medium w-[100px]">
                  {item?.staff_id || "N/A"}
                </TableCell>
                <TableCell>
                 <div className="flex items-center gap-2">
                    <div className="flex w-8 items-center gap-2">
                      <img
                        src={item?.file_manager_url || blackUser}
                        alt={item?.name}
                        className="w-8 h-8 rounded-full"
                      />
                    </div>
                    <span className="flex-1">{item?.name || "N/A"}</span>
                  </div>
                </TableCell>
                <TableCell>{item?.designation || "N/A"}</TableCell>
                <TableCell>{item?.in_time || "0"}</TableCell>
                <TableCell>{item?.out_time || "0"}</TableCell>
                <TableCell>{formatHours(item?.break_hours)}</TableCell>
                <TableCell>{item?.out_time || "0"}</TableCell>
                <TableCell>{formatHours(item?.late_hour)}</TableCell>
                <TableCell>{formatHours(item?.overtime)}</TableCell>
                <TableCell>{formatHours(item?.working_hours)}</TableCell>
                <TableCell className="capitalize">
                  <div className="flex items-center gap-2">
                    <span
                      className={`inline-block w-2 h-2 rounded-full ${
                        item?.status?.toLowerCase() === "present"
                          ? "bg-cgreen"
                          : "bg-cred"
                      }`}
                    ></span>
                    <span
                      className={
                        item?.status?.toLowerCase() === "present"
                          ? "text-cgreen"
                          : "text-cred"
                      }
                    >
                      {item?.status || "N/A"}
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={12} className="text-center">
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </>
  );
}

export default SingleStaffDetailsTable;
